import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73cbf4c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchFrom" }
const _hoisted_2 = { style: {"margin-top":"20px"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  style: {"color":"gray","font-size":"13px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        name: "customized_form_controls",
        layout: "inline",
        model: $setup.searchFormState,
        ref: "searchFormRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "adsId",
            label: "广告ID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.adsId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchFormState.adsId) = $event)),
                placeholder: "请输入广告ID"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "userId",
            label: "用户ID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.userId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchFormState.userId) = $event)),
                placeholder: "请输入用户ID"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "status",
            label: "状态"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.status,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.searchFormState.status) = $event)),
                style: {"min-width":"120px"},
                placeholder: "请选择状态"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: "" }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "0" }, {
                    default: _withCtx(() => [
                      _createTextVNode("待办")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "1" }, {
                    default: _withCtx(() => [
                      _createTextVNode("已处理")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: "2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("已忽略")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                onClick: $setup.resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.search,
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_XAtable, {
        columns: $setup.columns,
        dataSource: $setup.tableData,
        loading: $setup.loading,
        scroll: { x: 1200 }
      }, {
        status: _withCtx(({ scope }) => [
          ((scope.record as any).status === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createVNode(_component_a_tag, { color: "orange" }, {
                  default: _withCtx(() => [
                    _createTextVNode("待办")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          ((scope.record as any).status === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createVNode(_component_a_tag, { color: "green" }, {
                  default: _withCtx(() => [
                    _createTextVNode("已处理")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          ((scope.record as any).status === 2)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _createVNode(_component_a_tag, { color: "gray" }, {
                  default: _withCtx(() => [
                    _createTextVNode("已忽略")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        userName: _withCtx(({ scope }) => [
          _createElementVNode("div", null, _toDisplayString(scope.record.userName), 1),
          (scope.record.userId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " ID:" + _toDisplayString(scope.record.userId), 1))
            : _createCommentVNode("", true)
        ]),
        control: _withCtx(({ scope }) => [
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: ($event: any) => ($setup.handleClick(scope.record as any, 1)),
            style: {"margin-right":"8px"},
            disabled: (scope.record as any).status !== 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("处理")
            ]),
            _: 2
          }, 1032, ["onClick", "disabled"])), [
            [_directive_permission, 'sysName.list.update']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            size: "small",
            onClick: ($event: any) => ($setup.handleClick(scope.record as any, 2)),
            disabled: (scope.record as any).status !== 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("忽略")
            ]),
            _: 2
          }, 1032, ["onClick", "disabled"])), [
            [_directive_permission, 'sysName.list.update']
          ])
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]),
      _createVNode(_component_a_pagination, {
        current: $setup.pageNo,
        "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => (($setup.pageNo) = $event)),
        onChange: $setup.pageNoChange,
        total: $setup.total,
        hideOnSinglePage: "",
        onShowSizeChange: $setup.onShowSizeChange,
        style: {"margin-top":"5px"}
      }, null, 8, ["current", "onChange", "total", "onShowSizeChange"])
    ])
  ], 64))
}